// extracted by mini-css-extract-plugin
export default {"image":"styles_image__SZVOM","title":"styles_title__A+chN"};